module.exports = __webpack_public_path__ + "media/images/pro_exclusive_mobile-486bc01c.svg";